import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils";

import { theme } from "../../../theme/css/theme.css";
import { responsive, transition } from "../../../utils";
import { disabledState } from "../../../theme/disabledState";

export const containerStyle = recipe({
  base: {
    overflow: "hidden",
    flexShrink: 0,
    userSelect: "none",
    ...responsive({
      s: {
        padding: theme.spacings.xxs,
      },
    }),
  },
  variants: {
    height: {
      static: {
        height: `calc(${rem(236)} + ${theme.spacings.xs} + ${theme.spacings.xs})`,
      },
      auto: {
        height: "auto",
      },
    },
    disabled: {
      true: {
        ...disabledState,
      },
    },
  },
  defaultVariants: {
    height: "static",
  },
});

export const yearPickerStyle = style({
  borderRadius: theme.borderRadiuses.xxs,
});

export const yearMonthStyle = recipe({
  base: {
    padding: `${theme.borderRadiuses.xxs} ${theme.borderRadiuses.xs}`,
    borderRadius: theme.borderRadiuses.xs,
    border: "1px solid transparent",
    transition: transition("background-color", "border-color", "color"),
    textAlign: "center",
  },
  variants: {
    selected: {
      true: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.onPrimary,
      },
    },
    default: {
      true: {
        cursor: "pointer",
        ":hover": {
          backgroundColor: theme.colors.primary,
          color: theme.colors.onPrimary,
          borderColor: theme.colors.primary,
        },
      },
    },
    current: {
      true: {
        borderColor: theme.colors.defaultBorder,
      },
    },
  },
});

export const wrapperStyle = style({
  overflow: "hidden",
});

export const dropdownContainerStyle = style({
  overflow: "hidden",
});

export const monthPickerStyle = style({
  borderRadius: theme.borderRadiuses.xxs,
});

export const calendarStyle = style({
  display: "grid",
  gridTemplateColumns: "repeat(7, 1fr)",
  gap: theme.spacings.xxs2,
  width: rem(220),
});

export const weekdayHeaderStyle = style({
  textAlign: "center",
  paddingBottom: theme.spacings.xxs,
});

export const dayCellStyle = recipe({
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: rem(26),
    borderRadius: theme.borderRadiuses.xs,
    border: "1px solid transparent",
    transition: transition("background-color", "border-color", "color"),
  },
  variants: {
    selected: {
      true: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.onPrimary,
      },
    },
    today: {
      true: {
        borderColor: theme.colors.defaultBorder,
      },
    },
    default: {
      true: {
        cursor: "pointer",
        ":hover": {
          backgroundColor: theme.colors.primary,
          color: theme.colors.onPrimary,
          borderColor: theme.colors.primary,
        },
      },
    },
  },
});

export const emptyCellStyle = style({
  visibility: "hidden",
});
